import { assertNever } from "@p0security/frontend-core";
import { Node } from "@p0security/shared/graph/types";
import { CredentialNode } from "@p0security/shared/types/assessment/data/credential";
import {
  AssessmentNodes,
  GrantNode,
  IdentityNode,
  ResourceNode,
  TargetNodeType,
} from "@p0security/shared/types/assessment/data/index";

import { CredentialNodeDisplay } from "./credential/CredentialNode";
import { GrantNodeDisplay } from "./grant/GrantNode";
import { IdentityNodeDisplay } from "./identity/IdentityNode";
import { ResourceNodeDisplay } from "./resource/ResourceNode";

export const NodeDisplay: React.FC<{
  node: Node<AssessmentNodes, TargetNodeType>;
}> = ({ node }) => {
  switch (node.type) {
    case "grant":
      return <GrantNodeDisplay node={node as GrantNode} />;
    case "credential":
      return <CredentialNodeDisplay node={node as CredentialNode} />;
    case "identity":
      return <IdentityNodeDisplay node={node as IdentityNode} />;
    case "resource":
      return <ResourceNodeDisplay node={node as ResourceNode} />;
    default:
      throw assertNever(node.type);
  }
};
